import React, { useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
//Import Firebase
import { getAuth, updateProfile } from "firebase/auth";
import { db } from "../../../firebase";
import { doc, setDoc } from "firebase/firestore";
//Import Context
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Import Components
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
//Import Icon
import downArrow from '../../../assets/icons/downArrow.svg';
import userLogo from '../../../assets/icons/userLogo.svg';
//Import CSS
import './userProfile.css';
import { set } from "date-fns";

function UserProfile() {
    const { currentUser, userData, fetchUserData } = useContext(AuthContext);

    const [inputName, setInputName] = useState(userData ? userData.displayName : '');
    const [inputPhone, setInputPhone] = useState(userData ? userData.phoneNumber : '');
    const [selectRegion, setSelectRegion] = useState(userData ? userData.region : '');
    const [selectCommune, setSelectCommune] = useState(userData ? userData.commune : '');
    const [messageConfirmation, setMessageConfirmation] = useState(false);
    const [messageError, setMessageError] = useState(false);

    // useEffect para formatear el número inicial si es necesario
    useEffect(() => {
        if (userData?.phoneNumber) {
            // Limpiar y formatear el número inicial
            const initialNumber = userData.phoneNumber.replace(/\D/g, '');
            if (initialNumber.startsWith('56')) {
                setInputPhone(`+56${initialNumber.substring(2)}`);
            } else {
                setInputPhone(`+56${initialNumber}`);
            }
        } else {
            setInputPhone('+56');
        }
    }, [userData]);

    const handleSelectChange = (selectedOption, { name }) => {
        if (name === 'region') {
            setSelectRegion(selectedOption.value);
            setSelectCommune('');
        }
        if (name === 'commune') {
            setSelectCommune(selectedOption.value);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') {
            setInputName(value);
        } else if (name === 'phone') {
            let numbers = value.replace(/\D/g, '');

            if (numbers.startsWith('56')) {
                numbers = numbers.substring(2);
            }

            numbers = numbers.substring(0, 9);
            // Formatear con el prefijo +56
            const formattedNumber = numbers ? `+56${numbers}` : '+56';
            setInputPhone(formattedNumber);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentUser) {
            const auth = getAuth();
            try {

                await updateProfile(auth.currentUser, {
                    displayName: inputName,
                    phoneNumber: inputPhone,
                });

                const userDocRef = doc(db, 'users', currentUser.uid);
                const userDataUpdated = {
                    displayName: inputName,
                    phoneNumber: inputPhone,
                    uid: currentUser.uid,
                };

                if (selectRegion) {
                    userDataUpdated.region = selectRegion;
                }
                if (selectCommune) {
                    userDataUpdated.commune = selectCommune;
                }
                
                await setDoc(userDocRef, userDataUpdated, { merge: true });
                // await fetchUserData();

                console.log('Perfil actualizado correctamente');

            } catch (error) {
                console.error('Error actualizando el perfil', error);
            }
        }
    };

    const regionData = staticData.regiones.find((region) => region.name === selectRegion);
    return (
        <section className='user-profile-content flex'>
            <h3 className='title-user'>Editar Perfil</h3>
            <section className='user-profile-box flex'>
                <form className='form-user-profile flex' onSubmit={handleSubmit}>
                    <div className='box-icon flex'>
                        <img src={userLogo} className='icon-profile' />
                    </div>
                    <section className='section-form flex'>
                        <span className='input-box flex'>
                            <label htmlFor='name' className='label label-name'>Nombre</label>
                            <input type='text' id='name' name='name' className='input input-name' placeholder='Ingresa nombre' value={inputName} onChange={handleInputChange} />
                        </span>
                        <span className='input-box flex'>
                            <p htmlFor='name' className='label'>Email</p>
                            <div className='input flex'>
                                <p>{userData && userData.email}</p>
                            </div>
                        </span>
                        <span className='input-box flex'>
                            <label htmlFor='phone' className='label label-phone'>Teléfono</label>
                            <input type='tel' id='phone' name='phone' className='input input-phone' maxLength='12' placeholder='Ej: +56XXXXXXXXX' value={inputPhone} onChange={handleInputChange} />
                        </span>
                        <span className='input-select flex'>
                            <label htmlFor='region' className='label-region'>Región</label>
                            <Select
                                name='region'
                                id='region'
                                options={staticData.regiones.map((region) => ({
                                    value: region.name,
                                    label: region.name
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))}
                                onChange={handleSelectChange}
                                value={selectRegion}
                                placeholder={selectRegion ? selectRegion : 'Selecciona una opción'}
                                className='custom-select'
                                classNamePrefix='custom-select'
                                components={{ DropdownIndicator }}
                            />
                        </span>
                        <span className='input-select flex'>
                            <label htmlFor='commune' className='label-region'>Comuna</label>
                            <Select
                                name='commune'
                                id='commune'
                                options={regionData && regionData.communes.map((commune) => ({
                                    value: commune.name,
                                    label: commune.name
                                }))
                                    .sort((a, b) => a.label.localeCompare(b.label))}
                                onChange={handleSelectChange}
                                value={selectCommune}
                                placeholder={selectCommune ? selectCommune : 'Selecciona una opción'}
                                className='custom-select'
                                classNamePrefix='custom-select'
                                components={{ DropdownIndicator }}
                            />
                        </span>
                        <span className='button-content flex'>
                            <button type="submit" className='button-user-profile'><p>Guardar cambios</p></button>
                        </span>
                    </section>
                </form>
            </section>
        </section>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};


export default UserProfile;